<template>
    <div v-if="list.length > 0" class="article_list">
        <div v-for="(article, index) in list"
             :key="index"
             class="article"
        >
            <a v-if="article.url && article.url.length > 0" :href="article.url" target="_blank">{{article.title}}</a>
            <span v-else>{{article.title}}</span>
        </div>
    </div>
</template>

<script>

  export default {
    name: "article-list",
    props: ['content'],
    computed: {
      list() {
        if (!this.content) {
          return [];
        }

        try {
          return JSON.parse(this.content);
        } catch (e) {
          /* eslint-disable */
          console.log(e);
          return [];
        }
      }
    }
  }
</script>

<style scoped>
    .article {
        font-size: 0.85rem;
        margin-bottom: 0.75rem;
        padding: 0.1rem 0.1rem 0.25rem 0.1rem;
        border-bottom: dotted 1px #C9C9C9;
    }
</style>